import React, { useState } from "react";
import { Box, Grid, Paper, Tabs, Tab, Alert } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SignIn, SignUp, ForgetPassword } from './Index';
import Image from '../../../assets/background.png';
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { axiosFetch } from '../../../utils/AxiosFetch';
import "../../../assets/Css/Login.css";
import wlogo from "../../../assets/wlogo.png";
import logo from "../../../assets/logo.png";

import { CustomizedSnackbar } from '../../../shared/index';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { useDispatch } from "react-redux";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary.anchor,
  backgroundColor: "#f1f8e9",
  height: "100vh",
}));

function Welcome() {
  var location = useLocation();
  var navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [isSignin, setIsSignin] = React.useState(false);
  const [isForget, setIsForget] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errMsg, setErrMsg] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleForgetPassword = () => {
    if (isForget) {
      setIsForget(false)
    }
    else {
      setIsForget(true)
    }
  }
  const handleLogin = (values) => {
    setLoading(true);
    axiosFetch({
      method: 'POST',
      url: '/account/login',
      requestConfig: {
        'email': values.email,
        'password': values.password
      }
    })
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem("argus_user", JSON.stringify(res.data));

          if (location.state) {
            navigate(location.state.from,{})
            // setTimeout(()=>{
              window.location.reload();             
            // },1000)
          }
          else {
            navigate('/dashboard');
            // setTimeout(()=>{
              window.location.reload();             
            // },1000);
          }
          setLoading(false)
        }
        if (res.status === 400) {
          setLoading(false)
          setErrMsg(true)
          // dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleError = () => {
    if (errMsg) {
      setErrMsg(false)
    }
  }
  return (
    <div className="argus-login-main">
      <Box sx={{ width: "100%" }}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{
            width: "100%",
            backgroundColor: "transparent",
          }}
        >
          <Grid item xs={12} md={6} lg={6} xl={6} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Item
              className="argus-logo-container"
              style={{
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div className="banner">
                <div className="logo-ai">
                  <img src={wlogo} alt="Ai Logo" className="brand-logo" data-testid="logo" />
                  {/* <h1>
                    Argus By
                    <br /> Aggregate Intelligence Inc.
                  </h1> */}
                </div>
              </div>
              {/* <h1 style={{ color: "white" }}>
                “The goal is to turn data into information and information into
                insight.”
              </h1> */}
            </Item>
          </Grid>
          <Grid item xs={12} sx={{ display: { xs: 'block', sm: 'none' } }}>
            <div className="banner">
              <div className="logo-ai">
                <img src={wlogo} alt="Ai Logo" className="brand-logo" data-testid="logo" />
                {/* <h1>
                    Argus By
                    <br /> Aggregate Intelligence Inc.
                  </h1> */}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6} alignItems="center" justifyContent="center">
            <Item
              className="login-container"
              style={{
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              {/* <Box alignItems="center" display="flex" justifyContent="center">
                            <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
                                <Tab
                                onClick={(event) => {
                                    event.preventDefault();
                                    setIsSignin(false);
                                }}
                                label="Sign up"
                                />
                                <Tab
                                onClick={(event) => {
                                    event.preventDefault();
                                    setIsSignin(true);
                                }}
                                label="Sign In"
                                />
                            </Tabs>
                        </Box> */}
              <div className="login-main">
                <img src={logo} alt="Ai Logo" className="logo" />
                {/* <h1>ARGUS</h1> */}
                {/* <div>{isSignin?<SignIn/>:<SignUp/>}</div> */}
                {isForget ? (
                  <ForgetPassword forgetpassword={handleForgetPassword} />
                ) : (
                  <>
                    <h2 className="login-heading" data-testid="signin-component">Welcome to the AIHub!</h2>
                    <p>Please sign-in to your account</p>
                    {errMsg ? <Alert severity="error">Invalid Credentials !</Alert> : ""}
                    <SignIn
                      forgetpassword={handleForgetPassword}
                      onSubmit={handleLogin}
                      isLoading={loading}
                      handleErr={handleError}
                    />
                  </>
                )}
              </div>
            </Item>
          </Grid>
        </Grid>
      </Box>
      <CustomizedSnackbar />
    </div>
  );
}
export default Welcome;
